<template>
  <div class="fixed_background_layer"
       :style="{
      backgroundColor: f_b.radio_val !== 'hidden' ? f_b[f_b.radio_val].color : '',
      backgroundImage:f_b.radio_val !== 'hidden' && f_b[f_b.radio_val].img !== '' ? 'url('+f_b[f_b.radio_val].img+')' : 'none',
      backgroundSize: f_b.radio_val !== 'hidden' ? f_b[f_b.radio_val].background_size : 'auto',
      backgroundRepeat: f_b.radio_val !== 'hidden' ? f_b[f_b.radio_val].background_repeat : 'repeat',
      backgroundPosition: f_b.radio_val !== 'hidden' ? f_b[f_b.radio_val].background_position : '0% 0%',
    }"
  ></div>
</template>

<script>
import i18n from '../../language/index'

    export default {
        name: "fixed_background_layer",
      computed:{
        f_b(){
          const obj = this.$store.state.myRender.common.fixed_background;
          if(this.$store.state.row.fixed.fixeding){
            return obj;
          }
          else{
            const no_fixed = JSON.parse(JSON.stringify(obj));
            no_fixed.default.background_position = '0% 0%';
            no_fixed.custom.background_position = '0% 0%';
            return no_fixed;
          }

        },

      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fixed_background_layer/index.vue